export default __webpack_public_path__ + "static/Inter-Regular-df2ccd6357e60268e2baee2250441710.woff";